/**
 * created by lei lei on 2020/5/29
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ResourceStatic from './ResourceStatic';
import {permissionCheck} from "../../../../utils";

export default class ResourceStaticComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let isAuth = permissionCheck("pms:resourceStatic:viewAll");//是否展示任务管理
        if(!isAuth){
            return <div></div>
        }
        return (
            <div className={'ResourceStaticComponents'} style={{width:'100%'}}>
             <ResourceStatic/>
            </div>
        )
    }

}